export default function Pencil() {
  return (
    <div>
      <svg
        width='24'
        height='25'
        viewBox='0 0 24 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_2257_12040)'>
          <path
            d='M13.6289 4.68717L19.6299 10.6881L6.5991 23.7189L1.24879 24.3095C0.53254 24.3887 -0.0726159 23.7831 0.00707158 23.0669L0.602384 17.7128L13.6289 4.68717ZM23.3414 3.79373L20.5238 0.976074C19.6449 0.097168 18.2194 0.097168 17.3405 0.976074L14.6897 3.62686L20.6907 9.62779L23.3414 6.97701C24.2204 6.09764 24.2204 4.67264 23.3414 3.79373Z'
            fill='#222222'
          />
        </g>
        <defs>
          <clipPath id='clip0_2257_12040'>
            <rect
              width='24'
              height='24'
              fill='white'
              transform='translate(0 0.316406)'
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
